import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

import { InviteSignUpPage } from "@/features/invitee/sign-up";

export const Route = createFileRoute(
  "/(member)/(public)/invite/$token/sign-up",
)({
  component: InviteSignUpPage,
  validateSearch: z.object({
    firstName: z.string().optional(),
    lastName: z.string().optional(),
  }),
  head: () => ({
    meta: [
      { title: "Birdwatch - Sign Up" },
      {
        name: "description",
        content: "Create your Birdwatch account to accept your invite",
      },
    ],
  }),
});
